import { render } from "./404.vue?vue&type=template&id=ed67a390"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=ed67a390&lang=css"
script.render = render

export default script